// The icons an author can pick for a user template. The backend only checks that
// an icon is an iconoir class, so this is the one list of them.
export const TEMPLATE_ICONS = [
  'iconoir-add-user',
  'iconoir-agile',
  'iconoir-airplane',
  'iconoir-airplane-rotation',
  'iconoir-album-open',
  'iconoir-antenna-signal',
  'iconoir-app-window',
  'iconoir-apple',
  'iconoir-balcony',
  'iconoir-bank',
  'iconoir-barcode',
  'iconoir-bathroom',
  'iconoir-book',
  'iconoir-book-stack',
  'iconoir-bookmark-empty',
  'iconoir-box-iso',
  'iconoir-calendar',
  'iconoir-car',
  'iconoir-cart',
  'iconoir-cart-alt',
  'iconoir-chat-bubble-question',
  'iconoir-chat-lines',
  'iconoir-check',
  'iconoir-check-circle',
  'iconoir-city',
  'iconoir-clipboard-check',
  'iconoir-clutery',
  'iconoir-code',
  'iconoir-coffee-cup',
  'iconoir-coin',
  'iconoir-coins',
  'iconoir-community',
  'iconoir-computer',
  'iconoir-cpu',
  'iconoir-dashboard',
  'iconoir-data-transfer-check',
  'iconoir-delivery-truck',
  'iconoir-dollar',
  'iconoir-double-check',
  'iconoir-ecology-book',
  'iconoir-edit-pencil',
  'iconoir-git-compare',
  'iconoir-globe',
  'iconoir-graduation-cap',
  'iconoir-group',
  'iconoir-health-shield',
  'iconoir-heart',
  'iconoir-home-hospital',
  'iconoir-home-user',
  'iconoir-hospital',
  'iconoir-house-rooms',
  'iconoir-industry',
  'iconoir-input-field',
  'iconoir-large-suitcase',
  'iconoir-learning',
  'iconoir-light-bulb-on',
  'iconoir-link',
  'iconoir-list-select',
  'iconoir-lock',
  'iconoir-locked-book',
  'iconoir-mail-out',
  'iconoir-math-book',
  'iconoir-media-image-list',
  'iconoir-money-square',
  'iconoir-neighbourhood',
  'iconoir-network',
  'iconoir-numbered-list-left',
  'iconoir-okrs',
  'iconoir-open-book',
  'iconoir-orthogonal-view',
  'iconoir-paste-clipboard',
  'iconoir-pc-check',
  'iconoir-pen-tablet',
  'iconoir-people-tag',
  'iconoir-pharmacy-cross-circle',
  'iconoir-phone-add',
  'iconoir-phone-income',
  'iconoir-pine-tree',
  'iconoir-pizza-slice',
  'iconoir-playlist-play',
  'iconoir-potion',
  'iconoir-profile-circle',
  'iconoir-receive-dollars',
  'iconoir-sea-and-sun',
  'iconoir-search',
  'iconoir-send-dollars',
  'iconoir-shield-alert',
  'iconoir-shield-eye',
  'iconoir-shield-question',
  'iconoir-shop-alt',
  'iconoir-sigma-function',
  'iconoir-sleeper-chair',
  'iconoir-small-shop',
  'iconoir-spock-hand-gesture',
  'iconoir-stats-report',
  'iconoir-strategy',
  'iconoir-system-restart',
  'iconoir-task-list',
  'iconoir-test-tube',
  'iconoir-timer',
  'iconoir-timer-off',
  'iconoir-tools',
  'iconoir-user-scan',
  'iconoir-user-square',
  'iconoir-verified-user',
  'iconoir-view-grid',
  'iconoir-walking',
  'iconoir-weight-alt',
  'iconoir-wrench',
]

export const DEFAULT_TEMPLATE_ICON = 'iconoir-view-grid'
